import { css } from 'styled-components';
import { StyledPublicFontFamily } from './StyledPublicFontFamily.tsx';
import { StyledRteHtmlTextNoFont } from './StyledRteHtmlTextNoFont.tsx';

const externalLink = {
  url: require('../style/image/export.svg'),
};
const pdfLink = {
  url: require('../style/image/file-pdf.svg'),
};

export const StyledRteHtmlText = css<{ c?: string }>`
  // Stili per il testo generato dell'editor RichTextInput

  // Importiamo gli stili di base
  ${StyledRteHtmlTextNoFont}

  // Aggiungiamo i font del tema pubblico
  ${StyledPublicFontFamily}
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a,
  ol,
  ul,
  dl {
    ${StyledPublicFontFamily};
  }

  // Icone per accesibilità
  a[href^="http://" i], a[href^="https://" i]
  {
    &::after {
      content: '';
      width: 18px;
      height: 18px;
      margin-left: 4px;
      background-color: ${props => props.theme.rteLinkColor};
      mask-image: url(${externalLink.url});
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      display: inline-block;
      vertical-align: middle;
    }

    &[href$='.pdf' i]::after {
      mask-image: url(${pdfLink.url});
    }

    &:hover::after {
      background-color: ${props => props.theme.rteLinkHoverColor};
    }
  }
`;
